export default __webpack_public_path__ + "static/media/notification_reminder_icon.1fa4bbfe.svg";